// extracted by mini-css-extract-plugin
export default {"hideTooltip":"Yaa-z","fadeIn":"Zaa-z","delay":"_aa-z","recommendedSizeTooltip":"aba-z"};